import React from 'react';
import {View} from 'react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';

import PercentageProgressListItem from '../PercentageProgressListItem';

import {styles} from './PercentageProgressListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={2}>Progress Bar</Heading>
      <Spacer size={16} />
      <Text>
        The progress bar progress is determined by the{' '}
        <Code>{'percentage'}</Code> prop or by <Code>{'numerator'}</Code> and{' '}
        <Code>{'denominator'}</Code> props.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        label="Group Qualifying Volume"
        readonly
      />
    </View>
    <Spacing size={20}>
      <Code>{'percentage={50}'}</Code>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        label="Group Qualifying Volume"
        readonly
        numerator={150}
        denominator={200}
      />
    </View>
    <Spacing size={20}>
      <Code>{'numerator={150} denominator={200}'}</Code>
    </Spacing>
  </>
);
